// src/lib/api.js
import axios from "axios";

export const LANG_KEY = process.env.REACT_APP_LANG_KEY || "site_lang";
const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000/api";

function detectDefaultLang() {
  try {
    const ls = localStorage.getItem(LANG_KEY);
    if (ls) return ls;
  } catch (e) {}
  try {
    return (navigator.language || "en").split("-")[0];
  } catch (e) {
    return "en";
  }
}

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    Accept: "application/json",
  },
});

export function setApiLang(lang) {
  try {
    if (lang) localStorage.setItem(LANG_KEY, lang);
    else localStorage.removeItem(LANG_KEY);
  } catch (e) {}
  const final = lang || detectDefaultLang();
  if (final) api.defaults.headers.common["Accept-Language"] = final;
  else delete api.defaults.headers.common["Accept-Language"];
}

// initialize default header
setApiLang(detectDefaultLang());

// request interceptor: ensure Accept-Language present and add params.lang for GETs when not provided
api.interceptors.request.use(
  (config) => {
    try {
      const lang = (localStorage.getItem(LANG_KEY) || detectDefaultLang()).split(",")[0];
      if (lang) {
        config.headers = config.headers || {};
        config.headers["Accept-Language"] = lang;
      }

      const method = (config.method || "get").toLowerCase();
      if (method === "get") {
        config.params = config.params || {};
        if (!("lang" in config.params)) {
          config.params.lang = lang;
        }
      }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (err) => Promise.reject(err)
);

// Response interceptor: a 401 almost always means the attached token is
// stale/expired. Clear it from the shared default header immediately so it
// doesn't keep poisoning subsequent requests — including public endpoints
// that never needed auth in the first place (e.g. the home page feed).
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      delete api.defaults.headers.common["Authorization"];
    }
    return Promise.reject(err);
  }
);

export default api;
export { detectDefaultLang };
